import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HhToasterComponent } from '@hoppy-hour/ui';

@Component({
  selector: 'hh-root',
  imports: [RouterOutlet, HhToasterComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('web');
}
